module.exports = __webpack_public_path__ + "202408221624/img/gold_4.09d2b96f.png";